import { Link } from 'react-router-dom';
import { Post } from '../../../lib/supabase';
import { categories } from '../../../data/categories';

const mockPickup = [
  {
    id: 'mock-1',
    slug: 'cursor-ai-workflow-full',
    title: 'CursorとClaudeで仕様書を書いてから実装する流れを整理した',
    excerpt: '「とりあえず作る」から「仕様を固めてから作る」に変えたら、手戻りが激減した。その具体的なフローを記録する。',
    category_slug: 'build-log',
    published_at: '2026-03-28',
    tags: [],
    featured: true,
    image_url: '',
    author_name: '',
    updated_at: '',
    created_at: '',
    content: '',
    image_map: null,
  },
  {
    id: 'mock-2',
    slug: 'vibe-coding-what-is',
    title: 'バイブコーディングとは何か——AIと一緒に作る感覚を言語化してみた',
    excerpt: 'コードを書くというより、AIと会話しながら形にしていく感覚。その実態と、うまくいくときの条件を整理した。',
    category_slug: 'ai-creation',
    published_at: '2026-03-20',
    tags: [],
    featured: true,
    image_url: '',
    author_name: '',
    updated_at: '',
    created_at: '',
    content: '',
    image_map: null,
  },
];

interface PostsPickupProps {
  posts: Post[];
}

export function PostsPickup({ posts }: PostsPickupProps) {
  const featured = posts.filter((p) => p.featured).slice(0, 2);
  const displayPosts = featured.length >= 2 ? featured : mockPickup;

  return (
    <div className="py-8 border-b border-[#E8E0D5] bg-[#F5EFE6]">
      <div className="max-w-2xl mx-auto px-4 sm:px-6">
        <p
          className="text-xs font-semibold tracking-widest uppercase text-[#5B7B6F] mb-4"
          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          まず読むならこれ
        </p>
        <div className="space-y-3">
          {displayPosts.map((post, index) => {
            const cat = categories.find((c) => c.slug === post.category_slug);
            return (
              <Link
                key={post.id}
                to={`/articles/${post.slug}`}
                className="flex items-start gap-4 group cursor-pointer"
              >
                <span
                  className="text-xl font-bold text-[#D4C9BE] leading-none mt-0.5 flex-shrink-0 w-6 text-right"
                  style={{ fontFamily: "'Georgia', serif" }}
                >
                  {index + 1}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    {cat && (
                      <span
                        className="text-xs text-[#5B7B6F] font-medium"
                        style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                      >
                        {cat.name}
                      </span>
                    )}
                  </div>
                  <h3
                    className="text-sm sm:text-base font-semibold text-[#2C2416] leading-snug group-hover:text-[#5B7B6F] transition-colors"
                    style={{ fontFamily: "'Noto Serif JP', serif" }}
                  >
                    {post.title}
                  </h3>
                  {post.excerpt && (
                    <p
                      className="text-xs text-[#7A6E62] mt-1 line-clamp-1 leading-relaxed"
                      style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                    >
                      {post.excerpt}
                    </p>
                  )}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
